import React, { useState } from 'react';
import ProjectCard from "../project/ProjectCard";

function ProfileProjects({ projects }) {
    const [filter, setFilter] = useState('');

    const q = filter.toLowerCase();
    const filtered = q
        ? projects.filter(p =>
            (p.title || '').toLowerCase().includes(q) ||
            (p.subtitle || '').toLowerCase().includes(q) ||
            (p.technology || '').toLowerCase().includes(q) ||
            (p.skill || '').toLowerCase().includes(q)
          )
        : projects;

    return (
        <div>
            <input
                type="text"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder="Filter projects..."
                style={{
                    width: '100%', padding: '8px 12px', marginBottom: 12,
                    border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
                    background: 'var(--surface)', color: 'var(--ink)', fontSize: 14,
                }}
            />
            <div className="row">
                {filtered.map(project => (
                    <ProjectCard project={project} key={project.id} />
                ))}
            </div>
        </div>
    );
}

export default ProfileProjects;